/* @flow */

import { observable, action, autorun } from 'mobx';

import KenticoService, { CONTENT_TYPE_NAMES } from 'services/KenticoService';
import type { KenticoDeliveryClientConfigurationStatus } from 'services/KenticoService';
import { PortalPromotionsCarousel, GlobalMessageBanner } from 'models/kentico';

export default class KenticoStore extends KenticoService {
  @observable portalPromotionsCarousel: {
    content: PortalPromotionsCarousel | void,
    loading: boolean,
  } = {
    content: undefined,
    loading: true,
  };

  @observable globalMessageBanner: {
    content: GlobalMessageBanner | void,
    loading: boolean,
  } = {
    content: undefined,
    loading: true,
  };

  constructor() {
    super();

    autorun(() => {
      switch (this.deliveryClient.configured) {
        case 'configured':
          this.loadPortalPromotionsCarousel();
          this.loadGlobalMessageBanner();
          break;

        case 'no-key':
          this.setDataToEmpty();
          break;
      }
    });
  }

  @action loadPortalPromotionsCarousel = async () => {
    this.portalPromotionsCarousel.loading = true;
    const fetchResult = await this.deliveryClient.getItems(
      CONTENT_TYPE_NAMES.portalPromotionsCarousel
    );

    this.portalPromotionsCarousel.content = fetchResult[0] || undefined;

    this.portalPromotionsCarousel.loading = false;
  };

  @action setDataToEmpty = () => {
    this.portalPromotionsCarousel.loading = false;
    this.portalPromotionsCarousel.content = undefined;
  };

  @action loadGlobalMessageBanner = async () => {
    this.globalMessageBanner.loading = true;
    const fetchResult = await this.deliveryClient.getItems(CONTENT_TYPE_NAMES.portalGlobalMessage);

    this.globalMessageBanner.content = fetchResult[0] || undefined;
    this.globalMessageBanner.loading = false;
  };
}
